module.exports = __webpack_public_path__ + "static/media/QuickSwap_logo.723d932f.png";